import React from 'react';

// Consistent card styling shared by every auth page (login, register,
// forgot/reset password) so the auth flow feels like one product.
// Two size tiers: 'compact' (440px — login, forgot/reset password) and
// 'wide' (640px — the 7-field register form). Defaults to compact.
export const authCardClass = (size = 'compact') =>
    `rounded-lg shadow-2xl border bg-white p-5 sm:p-6 w-full auth-card-${size}`;

// After a failed rsuite form check(), move keyboard focus to the first
// field showing a validation error (display-only a11y helper).
export const focusFirstError = () => {
    setTimeout(() => {
        const errorMessage = document.querySelector('.rs-form-error-message-wrapper');
        const group = errorMessage && errorMessage.closest('.rs-form-group');
        const input = group && group.querySelector('input, textarea');
        if (input) input.focus();
    }, 0);
};

// Shared shell for the auth pages: hexagon backdrop with the Newtonshow
// logo + tagline above the card. The logo block is identical on every
// auth page and anchored to the upper third (not dead-center), so the
// layout doesn't jump when navigating between login/register/forgot.
const AuthLayout = ({ children }) => (
    <div
        className="flex flex-col w-full min-h-screen items-center p-4"
        style={{ paddingTop: '8vh' }}
    >
        {/* Fixed full-viewport backdrop: painting the pattern on the scrolling
            wrapper leaves a white seam below the fold on iOS Safari, where the
            collapsing toolbar makes the visual viewport taller than 100vh. */}
        <div
            className="fixed inset-0 bg-blue-tech-hexagon-modern"
            aria-hidden="true"
            style={{ zIndex: -1 }}
        />
        <img src="/logo.webp" alt="Newtonshow" style={{ width: 170 }} />
        <p className="text-gray-700 text-sm mt-1 mb-5">Book camps for kids aged 3–14</p>
        {children}
    </div>
);

export default AuthLayout;
